import $, {Cash} from 'cash-dom';
import { cLog, historyReplace, getCleanUrl } from '../humans/helper';
import { log } from 'console';

/**
 * Search Module
 * Handles filtering and sorting for the search module
 * @package KAA
 * @author Tim Jungmann <Tim@Humans-Machines.com>
 */
export default class ReadMore {
    /**
     * Singleton instance of the component
     */
    static #instance: ReadMore;

    /**
     * Cash body reference
     */
    protected $body: Cash;

    /**
     * UI references
     */
    protected ui = {
		moreBody: '.js-more-body',
        moreTrigger: '.js-more-trigger',
    }

    /**
     * Read more constructor
     */
    protected constructor() {
        this.$body = $('body');
        this.registerEvents();
    }

    /**
     * Returns the singleton instance of the component
     */
    public static getInstance(): ReadMore {
        if (!ReadMore.#instance) {
            ReadMore.#instance = new ReadMore();
        }

        return ReadMore.#instance;
    }

    /**
     * Register required DOM and PubSub events
     */
    protected registerEvents(): void {
        this.$body.on('click', this.ui.moreTrigger, this.showMore.bind(this));
    }

    /**
     * Set initial sorting of search results once the site is loaded
     */
    protected showMore(event: Event): void {
        const $target = $(event.currentTarget as HTMLElement);

        // Show more text
        $target.closest(this.ui.moreBody).addClass('show-more');
    }
}
